import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/lib/api";

let cache = null;

export function useProducts() {
  const [products, setProducts] = useState(cache);
  const [loaded, setLoaded] = useState(!!cache);

  useEffect(() => {
    if (cache) return;
    axios
      .get(`${API}/products`)
      .then(({ data }) => {
        cache = data.products || [];
        setProducts(cache);
      })
      .catch(() => {
        cache = [];
        setProducts([]);
      })
      .finally(() => setLoaded(true));
  }, []);

  return { products: products || [], loaded };
}

export function useCurrentLots() {
  const [lotsBySku, setLotsBySku] = useState({});
  useEffect(() => {
    axios
      .get(`${API}/lots`)
      .then(({ data }) => {
        const map = {};
        (data.lots || [])
          .filter((l) => l.status === "Current")
          .forEach((l) => {
            if (!map[l.product_sku]) map[l.product_sku] = l;
          });
        setLotsBySku(map);
      })
      .catch(() => {});
  }, []);
  return lotsBySku;
}
